"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyStatus = void 0;
var SupplyStatus;
(function (SupplyStatus) {
    SupplyStatus["WIP"] = "work-in-progress";
    SupplyStatus["AWAIT_VKT"] = "await-vkt";
    SupplyStatus["ARCHIVE"] = "archive";
})(SupplyStatus = exports.SupplyStatus || (exports.SupplyStatus = {}));
//# sourceMappingURL=supply.status.js.map